// ======================================================================
// File Name       : Radio
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Form } from 'react-bootstrap';
import { onChangeWrapper } from '../../utils/FormUtils';

class RadioWrapper extends Component {
  render() {
    return (
      <Form.Check
        type='radio'
        {...this.props}
        onChange={onChangeWrapper(this.props.onChange, this.props.value)} />
    );
  }
}

RadioWrapper.propTypes = {
  ...Form.Check.propTypes,
};
RadioWrapper.defaultProps = {
  ...RadioWrapper.defaultProps,
};
export default RadioWrapper;
